export default {
  navbar: {
    logOut: "退出登錄",
    home: "首頁",
    dashboard: "看板",
    screenfull: "全屏",
    exitScreenfull: "退出全屏",
    theme: "換膚",
    size: "佈局大小",
    stheme: "特色主题fanti",
  },
  login: {
    title: "SC E-Log",
    logIn: "登錄",
    username: "賬號",
    password: "密碼",
    oldPassword: "原密碼",
    newPassword: "新密碼",
    confirmPassword: "確認密碼",
    confirmModify: "確認修改",
    idTootip: "請輸入正確的用戶名",
    passwordTootip: "登錄密碼不可以少於六位數",
  },
  theme: {
    change: "換膚",
    documentation: "換膚文檔",
    tips: "Tips: 它區別于 navbar 上的 theme-pick, 是兩種不同換膚方法，各自有不同應用場景，請參考文檔。",
  },
  language: {
    message: "切換語言成功",
  },
  tagsView: {
    refresh: "刷新",
    close: "關閉",
    closeOthers: "關閉其他",
    closeAll: "關閉所有",
  },
  report: {
    edit: "编辑",
    delete: "删除",
  },
  menu: {
    home: "首页",
    SystemMangerment: "系統管理",
    RoleManagement: "角色",
    ModulesManagement: "模塊",
    FieldManagement: "字段",
    MenuManagement: "選單 ",
    SISManagement: "權限管理",
    SISModuleManagement: "模塊",
    SISMenuManagement: "選單 ",
    baseinfomanagement: "基本資料管理",
    workcategorymanagement: "工作類別管理",
    department: "部門管理",
    factory: "廠別管理", //mock.js中funnameen
    position: "職級管理",
    positionrelationship: "職級關係管理",
    Operation: "操作",
    workchildcategorymanagement: "工作小類管理",
    industrycategorymanagement: "行業管理",
    industrydailycategorymanagement: "日誌行業管理",
    regionbasismanagement: "區域管理",
    projectmanagement: "設備管理",
    //customermanagement: '客戶管理',
    agentmanagement: "代理商管理",
    dailyrecordmanagement: "日誌管理",
    dailyrecord: "日誌",
    personalmanagement: "個人中心",
    SISGroupManagement: "權限群組管理",
    usermanagement: "用戶管理",
    user: "用戶",
    password: "修改密碼",
    authmanagement: "權限管理",
    group: "群組管理",
    menu: "選單 管理",
    servicemanagement: "服務管理",
    SISUserToGroupManagement: "用戶與群組關聯",
    SISGroupToMenusManagement: "群組與選單 權限關聯",
    orderservicemanagement: "服務申請",
    orderhandlemanagement: "處理追蹤",
    ElogBasicDataManagement: "基本資料",
    ElogJobClassification: "工作分類",
    ElogTechModule: "工作模塊",
    ElogTechSubModule: "子模塊",
    ElogTechName: "具體名稱",
    ElogTechRelate: "技術管理",
    ElogDemand: "需求管理",
    ElogDemandSource: "需求來源",
    ElogDemandObject: "需求對象",
    ElogSuportClassification: "支持類別",
    ElogSupportCategories: "支持類別",
    ElogProjectStage: "項目階段",
    ElogWeeklyProject: "項目維護",
    ElogWeeklyProjectMaintain:"項目維護",
    
    ElogCustomerRelate: "客戶管理",
    ElogWeeklyReportManagement: "周報管理",
    ElogGetWeeklyReport: "周報",
    ElogWeeklyReportMaintain:"進度維護",

    ElogIndustry: "行業管理",
    ElogStage: "階段",
    ElogCustomerClassification: "客戶類型",
    ElogSaleModel: "銷售模式",
    ElogCustomerRegion: "客戶區域",
    ElogCustomer: "客戶",
    ElogBU: "所屬BU",
    ElogUserClass: "課別",
    ElogUserDepartment: "部門",
    ElogUserInfo: "用戶",
    ElogUserRegion: "用戶區域",
    ElogUserRelate: "用戶管理",
    ElogUserCenter: "個人中心",
    ElogUpdatePassWord: "修改密碼",
    ElogResetPassWord: "重置密碼",
    ElogRecordManagement: "日誌管理",
     ElogProjectManagement: "專案管理",
    ElogAddProjectName: "新增專案",
    ElogGetProjectName: "新建專案",
    ElogProjectType: "方案類型",
    ElogProjectStatus: "狀態管理",
    ElogRecord: "日誌",
    ElogAddRecord: "新增日誌",
    ElogUserAuthority: "用戶權限",
    ElogAuthorityClass: "權限等級",
    ElogUserAuthorityManagement: "權限管理",
    ElogGetRecord: "查詢日誌",
    ElogCalendar: "填寫日曆",
    ElogReportChart: "報表",
    ElogComplementRate: "月填寫率",
    ElogDemandResourceChart: "需求來源",
    ElogJobClassificationChart: "工作分類",
    ElogJobModuleChart: "工作模塊/子模塊",
    ElogBusinessTipChart: "出差占比",
    ElogCustomerApply: "新增客戶",
    ElogCustomerConfirm: "客戶確認",
    ElogCustomerImport: "客戶導入",
    ElogEncodeRelate: "内容編碼",
    ElogCodeGenerateItem: "編碼組成項",
    ElogCodeClassification: "編碼類型",
    ElogCodeItemClassification: "編碼細項管理",
    ElogCodeItemDetail: "編碼組成項明細",
    ElogCodeDetail: "内容編號",
    ElogAutoMaticCode: "自動編碼",
  },
  common: {
    userno: "工號",
    department: "部門",
    userType: "用戶類型",
    sysManagerment: "系統管理員",
    managerment: "管理員",
    generalUsers: "一般用戶",
    allUserType: "所有類型",
     remberPassword:"記住密碼",
    search: "查詢",
    clear: "清空",
    add: "新增",
    copyAdd: "複製增加",
    export: "導出",
    edit: "修改",
    delete: "刪除",
    menus: "選單 ",
    nodes: "節點",
    modules: "模塊",
    workCategory: "工作類別",
    workChildCategory: "工作小類",
    industryCategory: "行業",
    industryDailyCategory: "行業",
    regionManage: "區域",
    project: "專案",
    customer: "客戶",
    agent: "代理商",
    position: "職級",
    factory: "廠別",
    operation: "操作",
    cancel: "取消",
    confirm: "確定",
    group: "群組",
    enable: "可用",
    disable: "不可用",
    allStatus: "全部狀態",
    deleted: "已刪除",
    yes: "是",
    no: "否",
    creator: "創建人",
    createDate: "創建時間",
    node: "節點",
    messageSucess: "操作成功",
    please: "請選擇",
    pleaseSelect: "請選擇",
    pleaseInput: "請輸入",
    status: "狀態",
    resent: "重送",
    description: "描述",
    startTime: "開始時間",
    endTime: "結束時間",
    pleaseSelectTime: "選擇日期",
    pleaseSelectGenerateItem: "請選擇編碼組成項！",
  },
  group: {
    groupId: "群組Id",
    groupName: "群組名稱",
    status: "群組狀態",
    description: "群組描述",
    menusContent: "選單 內容",
    selectedMenus: "已經指定的選單 ",
    updatedGroup: "維護",
    userMembers: "群組成員",
    selectedMembers: "已經指定的成員",
    menuGroup: "群組選單 ",
  },
  user: {
    userId: "賬號",
    loginName: "姓名",
    groupName: "群組名稱",
    add: "新增",
    edit: "修改",
    delete: "刪除",
    editLevel: "修改賬號權限",
    reset: "重置密碼",
    confirm: "確定密碼重置嗎？",
    successReset: "密碼重置成功",
    department: "部門",
    email: "EMAIL地址",
    userType: "用戶類型",
    commonUser: "一般用戶",
    superUser: "高級管理員",
    levelGroup: "權限群組",
    titlesLeft: "全部權限群組",
    titlesRight: "指定的權限群組",
    mailTooltip: "請輸入正確的郵箱地址",
  },
  menus: {
    menuName: "選單 名稱",
    displayName: "顯示名稱",
    parentName: "上級選單 ",
    moduleName: "模塊名稱",
    iconName: "選單 圖標",
    api: "API",
    menuUrl: "選單 Url",
    status: "選單 狀態",
    menuNameEn: "選單 英文名稱",
    menuNameEnMsg: "必須填入英文",
    usable: "選單 是否可用",
    confirm: "確認",
  },
  modules: {
    moduleName: "模塊名稱",
    moduleId: "模塊Id",
    status: "狀態",
    description: "模塊描述",
  },
  workCategory: {
    name: "工作類別名稱",
    description: "描述",
  },
  workChildCategory: {
    name: "工作小類名稱",
    description: "描述",
  },
  industryCategory: {
    name: "行業名稱",
    description: "描述",
  },
  regionManege: {
    name: "區域名稱",
    description: "描述",
  },
  customer: {
    name: "客戶名稱",
    code: "客戶代碼",
    description: "描述",
  },
  agent: {
    name: "代理商名稱",
    code: "編碼",
    description: "描述",
    createBy: "創建人",
  },
  project: {
    name: "設備名稱",
    description: "描述",
  },
  factory: {
    name: "工廠別",
    parentFacName: "上級廠別",
    description: "描述",
  },
  position: {
    name: "職級名稱",
  },
  operation: {
    name: "操作名稱",
  },
  route: {
    home: "首頁",
    password: "修改密碼",
    user: "用戶",
    department: "部門",
    machine: "設備管理",
    materialToFeeder: "料號管理",
    node: "節點管理",
    process: "製程管理",
    message: "流程信息管理",
    processDistribution: "程式分佈",
    report: "歷史報表",
    sisModule: "模塊",
    sisMenu: "選單 ",
    sisGroup: "群組管理",
    uploadSchedule: "上傳預排程",
    orderMerge: "工單群組合併",
    board: "看板",
    workCategory: "工作類別",
    workChildCategory: "工作小類",
    industryCategory: "行業",

    regionManage: "區域",
    project: "設備",
    customer: "客戶",
    agent: "代理商",
    factory: "廠別", //對應頁面標籤的標題
    positionRelationship: "職級關係",
    operation: "操作",
    position: "職級",
    dailyRecord: "日誌",
    add: "新增日誌",
    edit: "修改日誌",
    delete: "刪除日誌",
    group: "群組",
    menus: "選單 ",
    orderService: "工單服務申請單",
    orderServiceForm: "工單服務申請表",
    orderHandle: "工單處理追蹤",
    orderHandleForm: "工單處理追蹤表",
    jobClassification: "工作分類",
    techModule: "工作模塊",
    techSubModule: "子模塊",
    techName: "具體名稱",
    demandSource: "需求來源",
    demandObject: "需求對象",
    suportClassification: "支持類別",
    industry: "行業",
    stage: "階段",
    customerClassification: "客戶類型",
    saleModel: "銷售模式",
    customerRegion: "客戶區域",
    customerInfo: "客戶",
    customerRelate: "客戶管理",
    BU: "所屬BU",
    userClass: "課別",
    userDepartment: "部門",
    userInfo: "用戶",
    userRegion: "用戶區域",
    userRelate: "用戶管理",
    updatePassWord: "修改密碼",
    resetPassword: "重置密碼",
    projectName: "操作專案",
    getProjectName: "新建專案",
    projectType: "方案類型",
    projectStatus:"狀態",
    record: "日誌",
    addRecord: "操作日誌",
    authorityClass: "權限等級",
    userAuthorityManagement: "權限管理",
    getRecord: "查詢日誌",
    getElogCalendar: "填寫日曆",
    complementRate: "月填寫率",
    businessTipChart: "出差占比",
    demandResourceChart: "需求來源",
    jobClassificationChart: "工作分類",
    jobModuleChart: "工作模塊/子模塊",
    customerApply: "新增客戶",
    customerConfirm: "客戶確認",
    codeGenerateItem: "編碼組成項",
    codeClassification: "編碼類型",
    codeItemClassification: "編碼細項管理",
    codeItemDetail: "編碼組成項明細",
    codeDetail: "内容編號",
    autoMaticCode: "自動編碼",

    supportCategories: "支持類別",
    getWeeklyReport: "周報",
    weeklyReportMaintain:"進度維護",
    projectStage: "項目階段",
    weeklyProjectMaintain:"項目維護",
    weeklyProject:"項目維護",
  },
  dailyRecord: {
    date: "日期",
    selectDate: "選擇日期",
    workingHours: "工時",
    workCategory: "工作類別",
    workChildCategory: "工作小類",
    industryCategory: "行業",
    regionManage: "區域",
    customer: "客戶",
    equipment: "設備名稱",
    content: "内容",
  },
  order: {
    orderID: "工單編號",
    add: "新建申請單",
    edit: "編輯申請單",
    delete: "刪除申請單",
    handle: "處理申請單",
  },
  orderform: {
    applicantUserId: "申請人工號",
    applicant: "申請人信息",
    applicantDepartment: "需求單位",
    processDepartment: "處理單位",
    processResult: "處理結果",
    hopeServiceTime: "服務日期",
    projectInfo: "專案信息",
    customer: "客戶信息",
    servicecontent: "服務内容",
    processingresults: "SC處理結果",
    id: "服務單號",
    datetime: "申請日期",
    applicantNo: "申請人工號",
    applicantName: "申請人",
    applicantCompany: "申請單位",
    fieldContactor: "現場聯絡人",
    fieldContactorPhoneNum: "現場聯絡電話",
    serviceType: "服務類型",
    serviceAddress: "服務地址",
    productNum: "預估用量(套數)",

    salesModel: "銷售模式",
    DirectSelling: "直銷",
    agent: "代理商",
    youchang: "友厂",
    customerName: "客戶名稱",
    customerCode: "客戶code",
    agentName: "代理商名稱",
    agentCode: "代理商code",
    industry: "行業",
    equipment: "設備名稱",
    businessOpportunityNo: "商機代碼",
    requirementDes: "問題描述",
    businessCode: "商機代碼",

    productConfig: "產品内容",

    program: "方案開發",
    solveProblem: "應用問題處理",
    programAssessment: "方案評估",
    programCopy: "方案複製",
    fieldTest: "Field Test",
    train: "培訓",
    other: "其他",
  },
  orderhandle: {
    applicationId: "申請單號",
    processorId: "處理人工號",
    processorName: "處理人",
    department: "處理單位",
    serviceStatus: "服務狀態", ////服务状态0-指派中，1-进行中，已结案
    finishDtate: "完結日期",
    serviceType: "服務類型",
    distributorIsArrive: "代理商是否到場", //0-否 1-是
    distributorType: "代理商到場人員", //0-业务，1-技术
    distributorName: "代理商人員", //distributorInfo
    distributorPhoneNum: "代理商電話",
    DGCAFEIsArrive: "DGC是否到場", //0-否 1-是
    DGCAFEName: "DGC到場人員", //DGCAFEInfo
    DGCAFEPhoneNum: "DGC人員電話",
    fieldSystemArchitecture: "現場系統架構", //新增现场架构
    processResult: "解決方案", //当成解决方案
    benifit: "效益",
    businessNum: "出差單號",
    businessAddressUrl: "出差報告",
    yes: "是",
    no: "否",
    business: "業務",
    technology: "技術",
    startTime: "開始時間",

    marketInfo: "市場資訊",
    regionIndustryFocus: "区域行业聚集", //区域行业聚
    competitionInfo: "競品資訊", //增竞品资讯
    agentInfo: "代理商資訊", //代理商资讯
    estimateAndAdvice: "評價與建議", //增评估与意见
    requestTimes: "出差次數",
    requestStage: "階段",
    stageContent: "具體内容",
  },

  editPassword: {
    editPasswordTooltip: "修改的密碼不可以少於六位數",
    confirmNotNull: "確認密碼不能為空",
    confirmTooltip: "兩次密碼輸入不一致",
    successAlert: "密碼修改成功",
    successReset: "密碼重置成功",
  },
  logout: {
    title: "退出",
    tip: "您確定要退出嗎？",
  },
  dialog: {
    screenfullNotSupport: "当前瀏覽器不支持全屏，請使用最新版的瀏覽器",
  },
  e_log: {
    jobClassification: "工作分類",
    description: "描述",
    techModule: "工作模塊",
    techSubModule: "子模塊",
    techName: "具體名稱",
    demandSource: "需求來源",
    demandObject: "需求對象",
    suportClassification: "支持類別",

    supportCategories: "支持類別",
    getWeeklyReport: "周報",
    weeklyReportMaintain:"進度維護",

    industry: "行業",
    stage: "階段",
    customerClassification: "客戶類型",
    saleModel: "銷售模式",
    customerRegion: "客戶區域",
    customer: "客戶",
    customerRelate: "客戶管理",
    channelName: "渠道商",
    salesman:"地區業務",
    BU: "BU(多選)",
    BU1: "所屬BU1",
    BU2: "所屬BU2",
    userClass: "課別",
    userDepartment: "部門",
    region: "區域",
    userInfo: "用戶",
    userRegion: "用戶區域",
    userRelate: "用戶管理",
    userName: "用戶名",
    userEnName: "英文名",
    userId: "工號",
    updatePassWord: "修改密碼",
    resetPassword: "重置密碼",
    codeName: "内容編碼",
    customerName: "客戶名稱",
    startDate: "開始日期",
    endDate: "結束日期",
    record: "日誌",
    addRecord: "編輯日誌",
    workDate: "工作日期",
    pleaseSelectDate: "請選擇日期",
    pleaseSelect: "請選擇",
    pleaseInput: "請輸入",
    codeNo: "内容編號",
    demandDate: "需求提出日期",
    projectName: "專案名稱",
    projectType: "專案名稱",
    projectStatus:"狀態",
    deltaInternal: "需求窗口",
    Yes: "是",
    No: "否",
    isScDeveloped: "是否SC開發",
    systemArchitecture: "產品/系統架構",
    content: "具體内容",
    isEnd: "專案是否結案",
    WorkOut: "出差",
    WorkHome: "辦公室",
    JobLocation: "是否出差",
    IsChannelPresent: "渠道商是否到場",
    IsFAEPresent: "FAE是否到場",
    effectiveHours: "有效時數",
    effectiveHoursLimit: "0-24内有效數字",
    effectiveHoursLeave: "0-8内有效數字",
     samLimit:"大於0的有效數字",
    projectStartDate: "專案開始時間",
    estimatedEndDate: "期望結束時間",
    cancel: "取消",
    confirm: "確定",
    authorityClass: "權限等級",
    userAuthorityManagement: "權限管理",
    dateLimit: "時間範圍",
    authorityClassNo: "等級編號",
    customerConfirm: "客戶確認",
    codeGenerateItem: "編碼組成項",
    codeClassification: "編碼類型",
    codeItemClassification: "編碼細項管理",
    generateItemOrder: "編碼項序號",
    codeItemDetail: "編碼組成項明細",
    generateItemDetailsCode: "編碼",
    codeDetail: "内容編號",
    role: "角色",
    bindingName: "權限綁定",
    administrators: "管理員",
    normalUser: "普通用戶",
    IncludeCompetitors: "是否包含競品",
    Competitors: "競品信息",
    all: "共",
    dataCount: "條數據",
    pleaseInputSimplySelect: "請使用繁體輸入",
    pleaseInputKeysTosearch: "請輸入繁體關鍵字",
    Loading: "加載中",
    back: "返回",
    selectCodeItem: "自動編碼項",
    autoCoding: "自動編碼",
    isNew: "2025年數據",
    allCount: "已填寫",
    day: "天",
    allNeedWrite: "縂需填寫",
    allfillingRatio: "縂月填寫率",
    isResigned: "狀態",
    unResign: "在職",
    resign: "離職",
    resignTime:"離職時間"
  },
  BU: {
    MDSBU: "MDSBU:    變頻器",
    IMSBU: "IMSBU:    伺服",
    IMS_RABD: "IMS-RABD:    機器人",
    ICSBU: "ICSBU:    PLC/HMI",
    SSM_LOB: "SSM_LOB:   視覺/溫控器",
    AMBU: "AMBU:    智能製造",
    ISD_LOB: "ISD LOB:    CNC/CADCAM/橡塑行業",
    FASBD: "FASBD:    MES&SECS-GEM",
    IEMD:"IEMD:  綫馬/電鎖/電動夾爪",
    Other: "Other",
  },
  Chart: {
    start_month: "開始月份",
    end_month: "結束月份",
    separator: "至",
    jobLocation_ratio_total: "Total 出差/辦公室時間占比",
    jobLocation_ratio_month: "每月 出差/辦公室時間占比",
    workOut_home: "出差/辦公室",
    workOut_home_total: "Total_出差_辦公室",
    workOut_home_month: "每月_出差_辦公室",
    hours: "時數(h)",
    table_workOut_home: "出差_辦公室",
    demandResource_ratio_total: "Total 各需求來源時間占比",
    DGC_ratio_month: "每月 需求來自DGC的工作時間占比(%)",
    Overseas_ratio_month: "每月 需求來自海外的工作時間占比(%)",
    demandResource: "需求來源",
    jobclassification_ratio_total: "Total 各工作分類時間占比",
    jobclassification_ratio_month: "每月 各工作分類時間占比",
    jobclassification: "工作分類",
    name: "姓名",
    userClassName: "課別",
    fillingRatio: "月填写率",
    month: "月份",
    table_jobModule_subModule: "工作模塊_子模塊",
    table_jobModule_subModule_hours: "工作模塊_子模塊工作用時",
    jobModule_subModule: "工作模塊/子模塊",
    jobModule_subModule_hours: "工作模塊/子模塊工作用時",
    jobModule_subModule_hours_ratio: "工作模塊/子模塊工作用時占比",
    ratio: "占比",
    weekHours: "本周填寫時數：",
    monthHours: "本月填寫時數：",
    monthStandardHours: "本月標準工作時數：",
    itemRatio:"細項占比"
  },
   message: {
    versionUpdate:"檢測到版本更新，是否刷新頁面？",
    tip: "提示",
    sure: "確定",
    cancel:"取消"
    
  },
  //   ProjectRelate: {
  //   userName: "專案負責人",
  //   projectType: "方案類型",
  //   status: "狀態",
  //   SAM_Customer: "客戶SAM (K USD)",
  //   SAM_Project: "台達方案SAM (K USD)",
  //   startDate: "開始時間",
  //   estimatedEndDate: "預估結束時間",
  //   newEstimatedDate:"修改預估結束時間",
  //   modiFyRecord_EstimatedDate:"預估結束時間修改原因", 
  //   progress: "進度",    
  //   closeDate: "結案日期",
  //   modiFyRecord_CloseDate: "狀態修改原因",
  //   timeoutReminder:"方案已超過預計結束時間，請前往專案管理頁面進行維護！",
  //   modiFyEndCount: "結束時間修改次數",
  //   modiFyStatusCount:"狀態修改次數",
  //   reviewStatus: "審核狀態",
  //   audited: "已審核",
  //   to_be_reviewed: "待審核",
  //   review:"審核"
    
  // },
    
    ProjectRelate: {
    userName: "專案負責人",
    projectType: "方案類型",
    status: "狀態",
    SAM_Customer: "客戶SAM (K"+"\u00A0"+"USD)",
    SAM_Project: "台達方案SAM (K"+"\u00A0"+"USD)",
    startDate: "開始時間",
    estimatedEndDate: "預估結束時間",
    newEstimatedDate:"修改預估結束時間",
    modiFyRecord_EstimatedDate: "預估結束時間修改原因",
    progress: "進度",    
    closeDate: "結案日期",
    modiFyRecord_CloseDate: "狀態修改原因",
    timeoutReminder: "方案已超過預計結束時間，請前往專案管理頁面進行維護！",
    modiFyEndCount: "結束時間修改次數",
    modiFyStatusCount: "狀態修改次數",
    reviewStatus: "審核狀態",
    audited: "已審核",
    to_be_reviewed: "待審核",
    review: "審核",
    startDate_weekly: "周報開始時間",
    endDate_weekly: "周報結束時間",
    progressContent: "本周進度",
    weeklyStartDate: "周報開始時間",
    createBy: "填寫人",
    updateProgress: "維護進度",
    customerRelatedType: "客戶關聯性",
    customer_Related: '客戶相關',
    not_customer_Related: '非客戶相關',
    supportCategories: "支持類別",
    projectStage: "項目階段",
    total_progress: "項目總進度%",
    plans: "下周計劃",
    projectRequirements: "項目需求",
    background: "背景介紹",
    estimateTotalHours:"預計總工時(H)",
    effectiveHours: "本周有效時間(H)",
    projectStartDate: "項目開始時間",
    addCustomer: "新增客戶",
    progressLimit: "0-100内有效數字",
    effectiveHoursLimit: "0-168内有效數字",
    
  },
  PromptInfo: {
    please_input: "請輸入",
    please_input_simply: "請使用繁體輸入",
    please_note_unit: "請注意單位 (K USD)",
    please_select: "請選擇",
    please_systemArchitecture: "涉及到的產品或者整體架構",
    please_select_date: "請選擇時間",
    please_input_content: "本周工作内容總結，遇到的問題&解決方法，需要資源比如RD支援等",
    please_input_plans: "下周計劃要開展的工作",
    please_input_background: "客戶簡介，設備簡介，客戶訴求，客戶痛點等",
    please_input_demand: "具體需求可包括具體的速度，精度，設備功能等",
    please_input_reason: "請備注修改原因",
    please_input_total_hours: "項目的整體工時預估",
    please_input_bu:"涉及到的產品所屬BU"
  }
};
